import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import OrganizationPage from './pages/OrganizationPage';
import DashboardPage from './pages/DashboardPage';
import InputDataPage from './pages/InputDataPage';
import TutorialPage from './pages/tutorial/TutorialPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/select-organization" element={<OrganizationPage />} />
      <Route path="/tutorial" element={<TutorialPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/input-data/:docType" element={<InputDataPage />} />
      
    </Routes>
  );
}

export default App;
